import React from 'react';
import { motion } from 'framer-motion';

const Footer = () => {
  return (
    <footer className="relative bg-[#1a2332] border-t border-[#c9a961]/20 py-16 overflow-hidden">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        {/* Main footer content */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Logo and description */}
          <div className="space-y-6">
            <div className="inline-flex items-center justify-center bg-white rounded-xl border border-[#c9a961]/50 shadow-lg shadow-black/20 p-3 transition-all duration-500 hover:border-[#c9a961] hover:shadow-[#c9a961]/20">
              <img
                src="/logo.webp"
                alt="Johann C Strauss"
                className="h-24 w-auto"
              />
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              International Wealth Protection Attorney and Business Strategy Consultant providing confidential
              counsel to sophisticated clients worldwide.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-white font-serif text-xl mb-6">Services</h4>
            <ul className="space-y-3 text-gray-400 text-sm">
              <li className="hover:text-[#c9a961] transition-colors duration-300 cursor-pointer">
                Wealth Protection & Asset Structuring
              </li>
              <li className="hover:text-[#c9a961] transition-colors duration-300 cursor-pointer">
                International Trust & Banking Advisory
              </li>
              <li className="hover:text-[#c9a961] transition-colors duration-300 cursor-pointer">
                Cross-Border Business Strategy
              </li>
              <li className="hover:text-[#c9a961] transition-colors duration-300 cursor-pointer">
                Cross-Border Dispute Resolution
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-white font-serif text-xl mb-6">Contact</h4>
            <div className="space-y-3 text-gray-400 text-sm">
              <p>
                <span className="text-[#c9a961]">Written Inquiries:</span><br />
                <a
                  href="#consultation"
                  data-testid="footer-form-link"
                  className="hover:text-[#c9a961] transition-colors duration-300"
                >
                  Via confidential consultation form
                </a>
              </p>
              <p>
                <span className="text-[#c9a961]">Phone / WhatsApp:</span><br />
                <a
                  href="https://wa.me/27784312235"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="whatsapp-link-footer"
                  className="hover:text-[#c9a961] transition-colors duration-300"
                >
                  +27 78 431 2235
                </a>
              </p>
              <p>
                <span className="text-[#c9a961]">Office:</span><br />
                International Advisory
              </p>
            </div>
          </div>
        </div>

        {/* Legal Disclaimers */}
        <div className="border-t border-[#c9a961]/20 pt-8 mb-8">
          <h4 className="text-white font-semibold text-sm mb-4 uppercase tracking-wider">Legal Disclaimers</h4>
          
          <div className="space-y-4 text-xs text-gray-500 leading-relaxed">
            <p>
              <strong className="text-gray-400">Attorney-Client Relationship:</strong> The information on this website
              is for general informational purposes only and does not constitute legal advice. No attorney-client
              relationship is formed by use of this website or by contacting our office until a formal engagement
              agreement has been executed. Confidential or time-sensitive information should not be sent through
              this website.
            </p>
            
            <p>
              <strong className="text-gray-400">Confidentiality Statement:</strong> While we take every precaution
              to protect your privacy, communications via this website may not be completely secure. Communications
              between you and our firm become confidential only after an attorney-client relationship has been
              formally established. For matters requiring secure communication, please contact us to arrange
              appropriate encrypted channels.
            </p>
            
            <p>
              <strong className="text-gray-400">Jurisdiction-Specific Practice Notices:</strong> Johann C Strauss
              is qualified to practice law in specific jurisdictions. Legal advice and representation are provided
              in accordance with the laws and regulations of the relevant jurisdictions. In matters requiring local
              counsel in jurisdictions where we are not admitted, we work with qualified local attorneys to ensure
              proper representation. International clients should be aware that cross-border legal services may be
              subject to professional conduct rules in multiple jurisdictions.
            </p>

            <p>
              <strong className="text-gray-400">No Guarantee of Results:</strong> Prior results do not guarantee
              a similar outcome. Each legal matter is unique and must be evaluated on its own merits.
            </p>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-[#c9a961]/20 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-gray-500 text-sm">
            © {new Date().getFullYear()} Johann C Strauss. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm text-gray-500">
            <a href="#" className="hover:text-[#c9a961] transition-colors duration-300">Privacy Policy</a>
            <a href="#" className="hover:text-[#c9a961] transition-colors duration-300">Terms of Service</a>
            <a href="#" className="hover:text-[#c9a961] transition-colors duration-300">Cookie Policy</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
